import {
  type CreateSuntoryDedicatedShipmentOrderImportJobDto,
  apiClient,
  type ShipmentOrderImportJobExEntity
} from '@/libs/api'

export type CreateSuntoryDedicatedShipmentOrderImportJobRequest = {
  tenantKey: string
  dto: CreateSuntoryDedicatedShipmentOrderImportJobDto
}

export const createSuntoryDedicatedShipmentOrderImportJob = async ({
  tenantKey,
  dto
}: CreateSuntoryDedicatedShipmentOrderImportJobRequest): Promise<ShipmentOrderImportJobExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_jobs.suntory_dedicated.$post({
      body: dto
    })
  return data
}
